<template lang='pug'>
b-navbar
  template(slot='brand')
    b-navbar-item
      .content
        h1 CPE Scholar
  template(slot='end')
    b-navbar-item(v-if='isAuthenticated')
      p #[b Hello] {{userData.firstname}} {{userData.lastname}}
    b-navbar-item(v-if='isAuthenticated' @click='uiLogout')
      b-icon(icon='sign-in-alt' type='is-danger')
      p(class='has-text-danger') #[b Logout]



</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default{
  computed:{
    ...mapState('authentication',{
      isAuthenticated: s=>s.isAuthenticated,
      userData: s=>s.userData
    })
  },
  methods:{
    ...mapMutations('authentication', ['logout']),
    uiLogout(){
      this.logout()
      this.navigate('/')
    }
  }
}
</script>